import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MedelyDateTime } from '@medely/date-time-tools';
import { useRollbar } from '@mp/hooks';

export const useCancelScreening = (id?: number | null) => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const { rollbar } = useRollbar();

  const { mutate: cancelScreeningLegacy, isPending: isLegacyPending } = useMutation(
    () => axios.post(`/v3/professional/cancel_phone_screening`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['GetRecruitersForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetProfessionalScreeningsForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetCurrentUserForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['currentUser']);
      },
    },
  );

  const { mutate: cancelScreening, isPending } = useMutation(
    () => {
      if (!id) {
        rollbar.error('[Cancel Screening] Tried to cancel screening with missing id', { id });
        return Promise.reject(new Error('Cannot cancel screening: missing screening id'));
      }
      return axios.patch(`v3/professional/professional_screenings/${id}`, {
        professional_screening: {
          canceled_at: MedelyDateTime.now({ tz: 'system' }).dateTimeString,
        },
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['GetRecruitersForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetProfessionalScreeningsForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['GetCurrentUserForPhoneScreeningScheduled']);
        queryClient.invalidateQueries(['currentUser']);
      },
    },
  );

  return { cancelScreeningLegacy, isPending: isLegacyPending || isPending, cancelScreening };
};
